<template>
    <div>
        <el-table  :show-summary="true" :summary-method="getSummaries" ref="table" size="mini" border :data="tableData" :height="tableHeight"
                  :header-cell-style="{background:'#eef1f6',color:'#000'}">
            <el-table-column type="index" label="序号" show-overflow-tooltip width="45"></el-table-column>
<!--            <el-table-column prop="vc_gsname" label="公司" show-overflow-tooltip min-width="145"></el-table-column>-->
            <el-table-column prop="vc_pzsx" label="品种属性" show-overflow-tooltip ></el-table-column>
            <el-table-column prop="vc_pzname" label="研发产品" show-overflow-tooltip></el-table-column>
<!--            <el-table-column prop="vc_gsname" label="仓库" show-overflow-tooltip></el-table-column>-->
            <el-table-column prop="f_rd_expenditures_total" label="总研发支出" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="numberCss">{{scope.row.f_rd_expenditures_total}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="f_rd_expenses" label="研发费用" show-overflow-tooltip >
                <template slot-scope="scope">
                    <span class="numberCss">{{scope.row.f_rd_expenses}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="f_cb" label="成本金额" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="numberCss">{{scope.row.f_cb}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="dt_createtime" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="vc_lruname" label="录入人" show-overflow-tooltip></el-table-column>
        </el-table>

    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "MxPage",
        components: {},
        props: {
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                tableData:[],
                currentPage: 1,
                pageSize: 2000,
                total:0,
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.getExpenseDetailList();
            this.$nextTick(() => {
                this.onResize();
            })
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = 450;
                // this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getExpenseDetailList();
            },
            async getExpenseDetailList(){
                let param={
                    i_pid:this.data.i_pid,
                    i_pzid:this.data.i_pzid,
                };
                let res = await API.getExpenseDetailList(param);
                if (res.code==1){
                    this.tableData=res.data.list;
                    this.total=res.data.total;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    } else if (column.property=="f_rd_expenses"||column.property=="f_cb") {

                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0);
                            // console.log('column',column.property,sums[index])

                            sums[index] = Math.round(sums[index]*100)/100;
                        } else {
                            // sums[index] = 'N/A';
                        }
                    }
                });
                // console.log('column',sums)
                return sums;
            }
        },
    }
</script>

<style lang="scss" scoped>
.numberCss{
    text-align: right;
    font-weight: bold;
    display: inline-block;
    width: 100%;
}
/deep/{
    .el-table__footer-wrapper {
        position: absolute !important;
        bottom: 0;
        .cell{
            font-weight: bold;
            text-align: right;
        }
    }
    .el-table__body-wrapper{
        height: 377px !important;

    }
    /*.el-table::after{
        position:relative !important;
    }*/
}
</style>